/**
 * iOS Safari Compatibility Fixes
 * Runs on mount to fix layout issues specific to iOS devices
 */

const iosSafariPolyfill = {
  // Check if device is iOS
  isIOS() {
    return /iPhone|iPad|iPod/.test(navigator.userAgent);
  },

  // Check Safari browser
  isSafari() {
    return (
      /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
    );
  },

  // Initialize fixes
  init() {
    if (!this.isIOS()) return;

    // Fix 1: Force repaint on orientation change
    window.addEventListener("orientationchange", () => {
      setTimeout(() => {
        document.body.style.zoom = 0.99;
        document.body.style.zoom = 1;
      }, 100);
    });

    // Fix 2: Fix position fixed elements in iOS
    this.fixViewportHeight();

    // Fix 3: Fix carousel height on load
    setTimeout(() => this.fixCarousels(), 500);

    // Fix 4: Prevent bounce scrolling
    this.preventBounceScroll();
  },

  fixViewportHeight() {
    const setViewportHeight = () => {
      const height = window.innerHeight;
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${height}px`
      );
    };

    setViewportHeight();
    window.addEventListener("resize", setViewportHeight);
    window.addEventListener("orientationchange", setViewportHeight);
  },

  fixCarousels() {
    // Find all carousel elements and trigger resize
    const carousels = document.querySelectorAll(
      ".hooper, .slides, [class*='carouse']"
    );
    carousels.forEach((carousel) => {
      carousel.dispatchEvent(new Event("resize", { bubbles: true }));
      if (carousel.offsetHeight === 0) {
        carousel.style.minHeight = "300px";
      }
    });
  },

  preventBounceScroll() {
    let lastY = 0;
    document.addEventListener("touchstart", (e) => {
      lastY = e.touches[0].clientY;
    });

    document.addEventListener(
      "touchmove",
      (e) => {
        const currentY = e.touches[0].clientY;
        const isAtTop = window.pageYOffset === 0;
        const isAtBottom =
          window.pageYOffset + window.innerHeight >= document.body.scrollHeight;

        if ((isAtTop && currentY > lastY) || (isAtBottom && currentY < lastY)) {
          e.preventDefault();
        }
      },
      { passive: false }
    );
  },
};

// Start polyfill when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => iosSafariPolyfill.init());
} else {
  iosSafariPolyfill.init();
}

export default iosSafariPolyfill;
